import React, { useEffect, useState } from "react";
import { callDigitalAds } from "../../callApi/home";
// import { useDispatch } from "react-redux";
// import { setLoading } from "../../../../redux/slices";
import toast from "react-hot-toast";
import IsActive from "../AdminisActive";
import SaveButton from "../AdminButtons";

const DigitalAds = () => {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;

  const [data, setData] = useState({
    AdminId: AdminId,
    title: "",
    videos: [{ url: "" }, { url: "" }, { url: "" }],
  });

  const _data = data;
  const [option, setOption] = useState(false);


  const isEmpty = () => {
    let res = false;
    if (data.title === "") {
      res = true;
    }
    data.videos.forEach((item) => {
      if (item.url == "") {
        res = true;
      }
    });
    return res;
  };

  const handleSave = async () => {
  
    if (isEmpty()) {
      toast.error("Please fill in all values");
    } else {
      console.clear();
  
      const params = {
        content: JSON.stringify(data),
        showinwebsite: option ? 1 : 0,
        AdminId: AdminId
      };
  
  
      callDigitalAds(params).then((res) => {
        if (res) {
          toast.success("Data saved successfully");
        } else {
          toast.error("Something went wrong");
        }
      });
    }
  };
  

  useEffect(() => {
    const digitalAdsData = JSON.parse(sessionStorage.getItem("homeApi")).DigitalAds;
    if (digitalAdsData) {
      setData({
        title: digitalAdsData.heading || "",
        videos: digitalAdsData.media || [],
      });
      setOption(digitalAdsData ? (digitalAdsData.showinwebsite === 1) : false);
    }
  
  }, []);
 
  
  return (
    <div className="sec admin-digitalads">
      <h2>Digital Ads</h2>
      <main>
        <div className="input-field">
          {/* <input
            id="admin-digitalads-title"
            type="text"
            className="validate"
            onChange={(text) => {
              text = text.currentTarget.value;
              const _data = data;
              _data.title = text;
              setData((data) => ({
                ...data,
                ..._data,
              }));
            }}
            value={data.title}
          /> */}
          <label htmlFor="admin-digitalads-title">Title</label>
        </div>
        <div className="videos card">
          <h3>YouTube videos</h3>
    
          {data.videos.map((item, index) => (
            <div className="input-field" key={index}>
              <input
                id={"admin-digitalads-video" + index}
                type="text"
                className="validate digital-ads-input"
                onChange={(text) => {
                  text = text.currentTarget.value;
                  const _data = data;
                  _data.videos[index].url = text;
                  setData((data) => ({
                    ...data,
                    ..._data,
                  }));
                }}
                value={data.videos[index].url}
              />
              <label htmlFor={"admin-digitalads-video" + index}>Video URL</label>
            </div>
          ))}
        </div>
      </main>
      <div className="input-field">
        <label>

          <span>  <IsActive
              checked={option}
              onChange={() => setOption(!option)}
            /></span>
        </label>
      </div>
      <SaveButton onClick={handleSave} />
    </div>
  );
};

export default DigitalAds;
